// src/components/NetworkStatus.js
import React, { useState, useEffect } from "react";

export default function NetworkStatus() {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [showOnline, setShowOnline] = useState(false);
  const [offlineSince, setOfflineSince] = useState(null);
  const [elapsed, setElapsed] = useState(0);

  useEffect(() => {
    function handleOnline() {
      setIsOnline(true);
      setOfflineSince(null);
      setShowOnline(true);
      setTimeout(() => setShowOnline(false), 4000);
    }
    function handleOffline() {
      setIsOnline(false);
      setOfflineSince(new Date());
      setShowOnline(false);
    }
    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);
    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  useEffect(() => {
    if (!offlineSince) return;
    const interval = setInterval(() => {
      setElapsed(Math.floor((Date.now() - offlineSince) / 1000));
    }, 1000);
    return () => clearInterval(interval);
  }, [offlineSince]);

  function fmt(sec) {
    if (sec < 60) return `${sec}s`;
    if (sec < 3600) return `${Math.floor(sec / 60)}min`;
    return `${Math.floor(sec / 3600)}h`;
  }

  const isLong = elapsed > 300;

  if (isOnline && showOnline) {
    return <div style={{ ...s.banner, ...s.online }}>✅ Connexion rétablie — ventes synchronisées</div>;
  }
  if (!isOnline) {
    return (
      <div style={{ ...s.banner, ...(isLong ? s.danger : s.warning) }}>
        {isLong ? "🔴" : "🟠"}{" "}
        {isLong
          ? `⚠️ Hors-ligne depuis ${fmt(elapsed)} — Évitez de vendre des billets`
          : `📶 Hors-ligne depuis ${fmt(elapsed)} — Les ventes seront synchronisées à la reconnexion`}
      </div>
    );
  }
  return null;
}

const s = {
  banner: { padding:"0.6rem 1rem", textAlign:"center", fontSize:"0.85rem", fontWeight:"600" },
  online: { background:"#e8f5e9", color:"#1b5e20", borderBottom:"1px solid #a5d6a7" },
  warning: { background:"#fff8e1", color:"#e65100", borderBottom:"1px solid #ffe082" },
  danger: { background:"#ffebee", color:"#b71c1c", borderBottom:"1px solid #ffcdd2" },
};
